import React, { Component } from 'react';
import { registryCombineReducer } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/combineRegistry';
import PropTypes from 'prop-types';
import TaskEdit from './TaskEdit';

import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

class TaskEditWReducer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `editTaskForm-${props.match.params.taskId}`
    };
    registryCombineReducer(this.state.reducerName);
  }

  render() {
    return (
      <TaskEdit
        reducerName={this.state.reducerName}
        taskId={this.props.match.params.taskId}
      />
    );
  }
}

TaskEditWReducer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      taskId: PropTypes.string.isRequired
    })
  }).isRequired
};

export default ColumnsContent(TaskEditWReducer);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskEdit/index.js